'use strict';

(function ($) {
  var methods = {
    init: function () {
      // options are not used
      // var opts = $.extend({}, $.fn.k2_sidebarToggle.defaults, options);

      return this.each(function () {
        var $this = $(this);

        $this.find('> caption > .table-toggle').on('click', function () {
          $this.toggleClass('table-collapsed');
        });

      });

    }

  };

  $.fn.k2_tableCollapsible = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_tableCollapsible');
    }

  };

  $.fn.k2_tableCollapsible.defaults = {};

})(jQuery);
